"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Snackbar = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Snackbar = exports.Snackbar = (0, _mui.styled)(_mui.Snackbar)(({
  theme
}) => ({
  left: 15,
  right: 15,
  top: `calc(${_presentationUtils.CSS_MOBILE_WITH_TOP_AREA_BANNER_HEIGHT} + 15px)`,
  [theme.breakpoints.up('sm')]: {
    left: 'auto',
    right: 30,
    top: `calc(${_presentationUtils.CSS_DESKTOP_WITH_TOP_AREA_BANNER_HEIGHT} + 30px)`
  }
}));
